import { Box, styled } from '@mui/material';

export const ListItem = styled(Box)`
  box-shadow: inset 1px 0px 0px ${({ theme }) => theme.palette.ternary.main};
  padding: 0px 30px;
`;
